export const LEAD_CONTEXTS = {
  CRUNCHBASE: "CRUNCHBASE",
  GLOBALDATA: "GLOBALDATA",
  COMPANIES_HOUSE: "COMPANIES_HOUSE",
};
